import {
  Content,
  ContentRepresentation,
  OptionalCreatePageReference,
} from '@databases/types/confluence';
import { Database } from '@databases/types/database';
import { createPage } from '@databases/utils/confluence/page';
import { MacroLayout, serializeMacro } from '@databases/utils/macro';
import { CONTENT_EXPANSIONS } from '@databases/utils/redux/content/actions';

const DATABASE_MACRO_KEY = 'orderly-database';

/**
 * If the given parentPage field setting is a create page reference, create the page.
 */
export async function createParentPage(
  database: Database,
  parentPage: OptionalCreatePageReference
): Promise<Content | undefined> {
  if (parentPage.create) {
    return await createPage(
      {
        title: parentPage.contentTitle,
        space: { key: parentPage.spaceKey },
        ancestors: parentPage.create.parentPageId
          ? [{ id: parentPage.create.parentPageId }]
          : [],
        body: {
          storage: {
            representation: ContentRepresentation.STORAGE,
            value: serializeMacro(
              DATABASE_MACRO_KEY,
              {
                databaseSpace: database.space,
                databaseId: database.id,
              },
              undefined,
              {
                layout: MacroLayout.FULL_WIDTH,
              }
            ),
          },
        },
      },
      CONTENT_EXPANSIONS
    );
  }
}
